import React, {useState, useEffect} from 'react';
import {
  Button,
  Typography,
  Tooltip
} from '@mui/material';

export default function NavButton(props) {
  const { text, fontSize, buttonHeight, buttonWidth, style, disabled, dependsOn, currentForm, linkedForm, onClick, toolTip } = props
  const [isDisabled, setIsDisabled] = useState(disabled)
 
  // By putting ...style at the bottom of the style object
  // we ensure that any style passed as props will effectively overwrite the component's default
  const baseStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '0px 0px 0px 0px',
    backgroundColor: 'rgba(107, 164, 125, 1)',
    color: 'white',
    textTransform: 'none',
    ...style
  };

  const disabledStyle = {
    backgroundColor: 'rgba(20, 32, 24, 1)',
    color: 'rgb(68,94,73)',
  }


  const activeBarStyle = {
    width: '100%',
    background: 'white',
    height:'5px',
    opacity: currentForm == linkedForm ? '1' : '0'
  }

  const [myStyle, setMyStyle] = useState(baseStyle)

  const labelStyle = {
    paddingTop: '7px'
  }


  // If all of the fields that this button depends on have values (entry string lengths greater than 0)
  // Set disabled to false and apply the base style
  // Otherwise apply BOTH the base style and the disabled style, with the disabled style being applied last so that it overwrites any conflicts with the baseStyle
  useEffect(() => {
    if (isDisabled) {
      setMyStyle({...baseStyle, ...disabledStyle});
    } else {
      setMyStyle(baseStyle);
    }
  }, [isDisabled, currentForm]);

  let shouldDisable;
  if (dependsOn !== undefined) {
      shouldDisable = false;
      for(let item in dependsOn){
        if(dependsOn[item] !== undefined){
          if (dependsOn[item].length == 0) {
            shouldDisable = true;
            break;
          }
        }
      }
      if (isDisabled !== shouldDisable) {
        setIsDisabled(shouldDisable);
      }
  }else{
    // Otherwise if we are not using the dependsOn prop and ARE using the disabled prop, respect the disabled prop
    if (isDisabled !== disabled) {
      setIsDisabled(disabled);
    }
  }




  
    

  
   
 

  return (
    <Tooltip title={toolTip} placement='bottom' enterDelay={1000} arrow>
      <Button
        style={myStyle}
        disabled={isDisabled}
        onClick={onClick}
        disableRipple
      >
        <Typography style={labelStyle} fontSize={fontSize}>{text}</Typography>
        <div style={activeBarStyle}></div>
      </Button>
    </Tooltip>
  );
};